import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  // React Router hooks
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get current page from React Router location
  const currentPage = location.pathname === '/' ? 'home' : location.pathname.slice(1);

  const handleNavigation = (page) => {
    const path = page === 'home' ? '/' : `/${page}`;
    navigate(path);
  };

  return (
    <footer className="app-footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Company Section */}
          <div className="footer-brand-section">
            <div className="footer-logo">
              <div className="logo-icon">MP</div>
              <span className="logo-text">MintPrint.ai</span>
            </div>
            <p className="footer-description">
              Transform your photos into stunning printable art with AI-powered technology.
            </p>
            <div className="footer-contact">
              <a href="mailto:info@mintprint.ai" className="footer-email">
                info@mintprint.ai
              </a>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="footer-nav-section">
            <div className="footer-column">
              <h4 className="footer-heading">Create</h4>
              <ul className="footer-nav-list">
                <li>
                  <button 
                    onClick={() => handleNavigation('create')}
                    className={`footer-nav-link ${currentPage === 'create' ? 'active' : ''}`}
                  >
                    Create
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => handleNavigation('pricing')}
                    className={`footer-nav-link ${currentPage === 'pricing' ? 'active' : ''}`}
                  >
                    Pricing
                  </button>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Account</h4>
              <ul className="footer-nav-list">
                <li>
                  <button 
                    onClick={() => handleNavigation('dashboard')}
                    className={`footer-nav-link ${currentPage === 'dashboard' ? 'active' : ''}`}
                  >
                    Dashboard
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => handleNavigation('my-creations')}
                    className={`footer-nav-link ${currentPage === 'my-creations' ? 'active' : ''}`}
                  >
                    My Creations
                  </button>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Legal</h4>
              <ul className="footer-nav-list">
                <li>
                  <button 
                    onClick={() => handleNavigation('privacy-policy')}
                    className={`footer-nav-link ${currentPage === 'privacy-policy' ? 'active' : ''}`}
                  >
                    Privacy Policy
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => handleNavigation('terms-of-service')}
                    className={`footer-nav-link ${currentPage === 'terms-of-service' ? 'active' : ''}`}
                  >
                    Terms of Service
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => handleNavigation('cookie-policy')}
                    className={`footer-nav-link ${currentPage === 'cookie-policy' ? 'active' : ''}`}
                  >
                    Cookie Policy
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>© {currentYear} MintPrint.ai. All rights reserved.</p>
          </div>
          
          <div className="footer-meta">
            <span className="footer-version">v1.0.0</span>
            <span className="footer-separator">•</span>
            <span className="footer-status">
              <span className="status-indicator online"></span>
              All systems operational
            </span>
          </div>
        </div>

        {/* Legal Notice */}
        <div className="footer-legal-notice">
          <p>
            MintPrint.ai is an AI-powered service for creating personalized trading cards. 
            All generated content is for personal use unless otherwise specified. 
            By using our service, you agree to our Terms of Service and Privacy Policy.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
